<template>
  <li @click.capture="onClick">
    <router-link :to="to" v-bind="$attrs" class="navbar-brand" :active-class="activeClass">
      <slot>
        <span v-html="$t('common.navigation_' + to.name)"></span>
      </slot>
    </router-link>
  </li>
</template>

<script>
import emitter from '@/plugins/emitter';

export default {
  name: 'NavigationLink',

  inheritAttrs: false,

  props: {
    to: {
      type: Object,
      required: true,
    },

    activeClass: {
      type: String,
      required: false,
      default: 'active',
    },
  },

  methods: {
    onClick() {
      if (this.$route.name === this.to.name) {
        emitter.emit('navigationReload', this.to);
      }
    },
  },
};
</script>
